module.exports = __webpack_public_path__ + "img/incision-showcase-insta.b9644400.jpg";